import { useEffect } from "react";
import { Grid, Container, Toolbar, Fab, Fade, Box, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Sidebar from '../Sidebar/Sidebar';
//import FooterEnd from '../Footer/FooterEnd'
import HeaderMainProtected from '../Header/HeaderMainProtected'
import { useAuth } from '../../provider';
import { useTranslation } from '../../language';

/**
 * PageLayout - shared layout for protected pages
 * Includes: sidebar, header, footer, and scroll-to-top button
 */


export default function PageProtectedLayout({headline, specify, children, window, headlineMb, headlineFontWeight, headlineNoWrap, headlineVariant}) {

  const {state} = useAuth();
  const { changeLanguage } = useTranslation();

  useEffect(() => {
    if (state.user?.language) {
      changeLanguage(state.user.language);
    }
  }, [state.user?.language]);

return (
 <>
  {/* Layout Container */}
  <Box sx={{minHeight: '100vh', display: 'flex', flexDirection: 'column',  }}>

    <Container maxWidth={false} disableGutters sx={{ flexGrow: 1, }}>
      <Grid container>  
    
     {/* Anchor for ScrollTop */}
      <Toolbar  id="back-to-top-anchor" />
      
    {/* Sidebar */}
      <Sidebar />

    {/* Header Section (optional) */}
    {headline && (
      <Grid size={12} sx={{ 
                          mt: { xs: 6, md: 4, lg: 6},
                          mb: headlineMb ?? { xs: 4, sm: 6 }, 
                          //mb: { xs: 0, sm: 0 }, 
                          display: 'flex', justifyContent: 'center', alignItems: 'flex-start', 
                          }}>
        <HeaderMainProtected headline={headline} specify={specify} headlineFontWeight={headlineFontWeight} headlineNoWrap={headlineNoWrap} headlineVariant={headlineVariant}/>
      </Grid>
    )}

    {/* MAIN PAGE CONTENT */}
      <Grid size={12} sx={{display: 'flex', justifyContent: 'center', alignItems: 'flex-start'}}>
        {children}
      </Grid>
       
    </Grid>
  </Container>

    {/* Footer 
    <FooterEnd />
*/}
</Box>

{/* Scroll Back to Top */}
  <ScrollTop targetWindow={window}>
    <Fab size="small" aria-label="scroll back to top"
      sx={{
        zIndex: 9,
        bgcolor: 'primary.C200',
        color: 'primary.C900',
        '&:hover': { color: 'tertiary.C900' },
      }}
    >
      <KeyboardArrowUpIcon />
    </Fab>
  </ScrollTop>
</>
  );
}

/* Helper Function - Floating "scroll to top" button */
function ScrollTop({ children, targetWindow }) {
  const trigger = useScrollTrigger({
    target: targetWindow,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    const anchor = document.querySelector('#back-to-top-anchor');
    anchor?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
    });
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          zIndex: 14,
          position: 'fixed',
          bottom: 24,
          right: 24,
          cursor: 'pointer',
        }}
      >
        {children}
      </Box>
    </Fade>
  );
}

